import { string } from './type-checkers';

export default string.type('trackList').group('layout');
